// extracted by mini-css-extract-plugin
export default {"tab":"InventoryManagement_tab__EI-k8","active":"InventoryManagement_active__5dVU8"};